import React, { useMemo } from 'react';
import clsx from 'clsx';
import * as PropTypes from 'prop-types';
import { useTranslation } from 'react-i18next';
import { Link, Redirect, useParams } from 'react-router-dom';
import { Grid, Typography } from '@material-ui/core';

import usePage from '$app-web/hooks/use-page';
import Logo from '$app-web/modules/auth/components/logo';
import { getIsACT, URLsManager } from '$app-web/utils';

import Form from './components/form';
import FormWrapper from './components/form-wrapper';
import useStyles from './styles';

import { FontAwesomeIcon } from '$common/fontawesome-pro/react-fontawesome';

const PageSignUp = (props) => {
    const { hasStudyBasicInfo } = props;
    const { role } = useParams();

    const { t } = useTranslation();
    const classes = useStyles();

    usePage(t('pdash:login_signup_text'));

    const isACT = useMemo(() => getIsACT(), []);

    if (role !== 'participant' && hasStudyBasicInfo) {
        return <Redirect to={URLsManager.to('dashboard:auth:SIGN_UP_ROLE', { role: 'participant' })} />;
    }

    if (role) {
        if (role === 'participant' || role === 'researcher') {
            return (
                <FormWrapper role={role}>
                    <Form />
                </FormWrapper>
            );
        }
        return <Redirect to={URLsManager.to('dashboard:auth:SIGN_UP')} />;
    }

    return (
        <Grid
            item
            xs
            container
            direction="column"
            wrap="nowrap"
            className={clsx(classes.root, { [classes.actHealthColors]: isACT })}
        >
            {/*
                This method used to fix justify=center issue.
                https://stackoverflow.com/a/33455342
            */}
            <div className={classes.contentCenterWrapper}>
                <Grid item>
                    <Logo color="white" />
                </Grid>
                <Grid item container justify="center" className={classes.roleButtonsWrapper}>
                    <Grid
                        item
                        align="center"
                        className={classes.roleButton}
                        component={Link}
                        to={URLsManager.to('dashboard:auth:SIGN_UP_ROLE', { role: 'researcher' })}
                    >
                        <FontAwesomeIcon icon={['fad', 'graduation-cap']} size="4x" className={classes.roleButtonIcon} />
                        <Typography className={classes.roleButtonText}>{t('pdash:sign_up_you_are')}</Typography>
                        <Typography className={classes.roleButtonText} variant="button">
                            {t('pdash:signup_role_researcher')}
                        </Typography>
                    </Grid>
                    <Grid
                        item
                        align="center"
                        className={classes.roleButton}
                        component={Link}
                        to={URLsManager.to('dashboard:auth:SIGN_UP_ROLE', { role: 'participant' })}
                    >
                        <FontAwesomeIcon icon={['fad', 'user-alt']} size="4x" className={classes.roleButtonIcon} />
                        <Typography className={classes.roleButtonText}>{t('pdash:sign_up_you_are')}</Typography>
                        <Typography className={classes.roleButtonText} variant="button">
                            {t('pdash:signup_role_participant')}
                        </Typography>
                    </Grid>
                </Grid>
            </div>
        </Grid>
    );
};

PageSignUp.defaultProps = {
    hasStudyBasicInfo: false,
};

PageSignUp.propTypes = {
    hasStudyBasicInfo: PropTypes.bool,
};

export default PageSignUp;
